import { render, staticRenderFns } from "./GalleryGrid.vue?vue&type=template&id=5b2e8a82&scoped=true&"
import script from "./GalleryGrid.vue?vue&type=script&lang=ts&"
export * from "./GalleryGrid.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryGrid.vue?vue&type=style&index=0&id=5b2e8a82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e8a82",
  null
  
)

export default component.exports